var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.044,
    height: 26.021,
    viewBox: "0 0 26.044 26.021",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "send_1_",
    "data-name": "send (1)",
    transform: "translate(-3.5 -1.496)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M29,13.61,6,1.61A1,1,0,0,0,4.62,2.88l3.75,9a1,1,0,0,0,.92.62H12.5a1,1,0,0,0,0-2H9.92L7.48,4.66,26.34,14.5,7.48,24.34,9.92,18.5H12.5a1,1,0,0,0,0-2H9.25a1,1,0,0,0-.92.62l-3.75,9A1.009,1.009,0,0,0,6,27.39l23-12a1,1,0,0,0,0-1.78Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M18.5,14.5a1,1,0,0,0-1-1H4.5a1,1,0,0,0,0,2h13A1,1,0,0,0,18.5,14.5Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.65f6e48a918b0e8f0d1958cd948f10ac.svg";
export { ForwardRef as ReactComponent };